export default "__VITE_ASSET__87cfe2c5__"